import { api, ApiTags } from '../../api';
import type { SetUserAgreementRequest, SetUserAgreementResponse, GetMyUserAgreementResponse } from './types';

/**
 * API сервис для работы с пользовательским соглашением
 */
const userAgreementApi = api.injectEndpoints({
    endpoints: build => ({
        /**
         * Получает текущее согласие пользователя
         */
        getMyUserAgreement: build.query<GetMyUserAgreementResponse, void>({
            query: () => '/user-agreement/my',
            providesTags: [{ type: ApiTags.UserAgreement, id: 'MY' }],
        }),

        /**
         * Устанавливает согласие пользователя (публичность профиля)
         */
        setUserAgreement: build.mutation<SetUserAgreementResponse, SetUserAgreementRequest>({
            query: body => ({
                url: '/user-agreement',
                method: 'POST',
                body,
            }),

            // Оптимистичное обновление кэша
            onQueryStarted: async ({ isPublic }, { dispatch, queryFulfilled }) => {
                // Обновляем кэш для getMyUserAgreement
                const patchResult = dispatch(
                    userAgreementApi.util.updateQueryData('getMyUserAgreement', undefined, draft => {
                        if (draft) {
                            draft.isPublic = isPublic;
                            draft.updatedAt = new Date().toISOString();
                        }
                    }),
                );

                try {
                    await queryFulfilled;
                } catch {
                    // При ошибке откатываем изменения
                    patchResult.undo();
                }
            },

            // Инвалидация кэша для гарантированного обновления
            invalidatesTags: [{ type: ApiTags.UserAgreement, id: 'MY' }],
        }),
    }),
});

export const { useGetMyUserAgreementQuery, useSetUserAgreementMutation } = userAgreementApi;
export * from './types';
